export const conciergeStarters: string[] = [
  'We have 14 guests. Which properties fit?',
  'Which property is beachfront?',
  'Which one has a golf cart?',
  'We want 30A, a private pool, and room for 10.',
  'Which properties are in Panama City Beach?',
];
